import { KeyValue } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import {
  AuthService,
  ClientService,
  IClient,
  ToastService,
} from 'src/app/core';

@Component({
  selector: 'ic-deactivate',
  templateUrl: './deactivate.component.html',
  styleUrls: ['./deactivate.component.scss'],
})
export class DeactivateComponent implements OnInit {
  public loginForm: FormGroup;
  public formErrors: any = {};
  public clientConfig: IClient;

  constructor(
    private readonly fb: FormBuilder,
    private readonly clientService: ClientService,
    private readonly toastService: ToastService,
    private readonly authService: AuthService,
    private readonly router: Router,
  ) {
    this.clientConfig = this.clientService.currentClientValue;
  }

  ngOnInit(): void {
    this.loginForm = this.fb.group({
      email: [
        '',
        [Validators.required, Validators.maxLength(30), Validators.email],
      ],
    });

    // This forces validation.
    Object.keys(this.loginForm.controls).forEach((key) => {
      this.loginForm.get(key).markAsTouched();
    });

    this.loginForm.valueChanges.subscribe((changes) => {
      Object.keys(changes).forEach((controlName) => {
        const control = this.loginForm.controls[controlName];
        this.formErrors[controlName] =
          (control.touched || control.dirty) && control.errors ? 'error' : null;
      });
    });
  }

  get fc() {
    return this.loginForm.controls;
  }

  trimEmail() {
    const val = this.loginForm.get('email').value.trim();
    this.loginForm.get('email').setValue(val);
  }

  onSubmit() {
    const model = {
      key: this.clientConfig.restaurantId,
      value: this.loginForm.get('email').value.trim(),
    } as KeyValue<number, string>;
    this.authService.deactivateAccount(model).subscribe(
      (x) => {
        if (x.isSuccess) {
          this.toastService.showSuccess(
            'Account deactivation link has been sent successfully to your registered emai id'
          );
          this.router.navigate(['/home']);
        } else {
          this.toastService.showError(x.errors[0]);
        }
      },
      (err) => {
        this.toastService.showError(err.exceptionMessage || err.message);
      }
    );
  }
}
